import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import saveSSOConfig from '@/API/SSO/saveSSOConfig';

const useSaveSSOConfig = () => {
    return useMutation({
        mutationFn: saveSSOConfig,
        onSuccess: (_, variables) => {
            const isUpdate = !!variables.id;
            toast.success(
                isUpdate
                    ? 'SSO has been saved successfully!'
                    : 'SSO has been created successfully!',
            );
        },
        onError: (error) => {
            toast.error(error?.response?.data?.message);
        },
    });
};

export default useSaveSSOConfig;
